<template id="template-radio">
  <div
    :dir="$store.state.rightAlign ? 'rtl' : 'ltr'"
    :class="isPreview ? 'pb-2 mb-2' : 'bg-light p-3 pb-5 mb-2'"
  >
    <!-- menu buttons -->
    <MenuButtons
      v-if="!isPreview"
      :fieldData="fieldData"
      :collapse="collapse"
      :isHidden="isHidden"
      :label="label"
      v-on:toggle-field="showSettings = !showSettings"
      v-on:collapse-field="collapse = !collapse"
      :sectionIndex="sectionIndex"
      :fieldIndex="fieldIndex"
    />
    <b-collapse
      v-show="JSON.parse(!fieldData.isHidden) || !isPreview"
      :class="isPreview ? 'mt-2' : 'mt-5'"
      id="collapse-1"
      v-model="collapse"
    >
      <b-row>
        <b-col cols="12" class="text-right">
          <b-button
            v-if="fieldData.isConditional == '1' && !isPreview"
            variant="outline-dark"
            disabled
            title="This field is hidden by default and will display bt is controlled element"
          >
            <font-awesome-icon icon="eye-slash" />
          </b-button>
        </b-col>
      </b-row>
      <p class="text-left ml-1" v-if="fieldData.headerText && fieldData.headerText[selectedLanguage] != '' ">{{fieldData.headerText[selectedLanguage] }}</p>
      <b-row>
        <b-col cols="12" class="text-left">
          <b-form-group
            :class="$store.state.rightAlign ? 'text-right' : 'text-left'"
            :id="fieldData.id"
            :description="fieldData.helperText[selectedLanguage]"
            :invalid-feedback="fieldData.validationMessage[selectedLanguage]"
          >
            <label>
              <span
                v-if="
                  fieldData.validation && fieldData.validation.required == 1
                "
                class="required-span"
                >*</span
              >
              {{
                form1.enableSectionFieldEnumeration == 1
                  ? sectionIndex + 1 + "." + (fieldIndex + 1)
                  : ""
              }}
              {{ label ? label : fieldData.label[selectedLanguage] }}
              <br />
              <!-- &nbsp; -->
              <span v-if="fieldData.hyperLinkTextBefore"
                >{{ fieldData.hyperLinkTextBefore[selectedLanguage] }}
              </span>
              <b-link
                v-if="fieldData.hyperLinkUrl"
                target="_blank"
                :href="fieldData.hyperLinkUrl[selectedLanguage]"
                >{{
                  fieldData.hyperLinkText
                    ? fieldData.hyperLinkText[selectedLanguage]
                    : fieldData.hyperLinkUrl[selectedLanguage]
                }}</b-link
              >
              <span v-if="fieldData.hyperLinkTextAfter">
                {{ fieldData.hyperLinkTextAfter[selectedLanguage] }}</span
              >
            </label>
            <div class="clearfix"></div>
            <b-form-radio-group
              :stacked="fieldData.configuration.isStacked"
              :disabled="isDisabled == 1"
              :class="$store.state.rightAlign ? 'text-right' : 'text-left'"
              v-model="fieldData.selected"
              :options="radioOptions"
              @change="checkCondition"
            ></b-form-radio-group>
            <label
              v-if="
                fieldData.validation &&
                  fieldData.validation.required == 1 &&
                  !selected &&
                  isFocus
              "
              class="text-danger"
              >{{ fieldData.validationMessage[selectedLanguage] }}</label
            >
          </b-form-group>

          <!-- conditional input field -->
          <b-collapse v-model="showCollapseField" class="mt-2">
            <!-- v-show="conditionalFieldIsVisible == 1" -->
            <div
              v-for="(input, index) in fieldData.selectedMutiInputs"
              :key="index"
            >
              <!-- :invalid-feedback="fieldData.conditionalFieldValidationMessage[selectedLanguage]" -->

              <b-form-group
                :class="
                  $store.state.rightAlign
                    ? 'text-right ml-3 '
                    : 'text-left ml-3'
                "
                :description="
                  fieldData.conditionalFieldHelperText[selectedLanguage]
                "
                :label="fieldData.conditionalFieldLabel[selectedLanguage]"
                :invalid-feedback="
                  msg.xss
                    ? $t('createProfile.invalidInputMessage')
                    : $t('createProfile.requiredValidationMessage')
                "
              >
                <b-form-textarea
                  v-model="conditionalFieldInputValue"
                  :class="$store.state.rightAlign ? 'text-right' : 'text-left'"
                  @input="onInputType"
                  :disabled="isDisabled == 1"
                  :placeholder="
                    fieldData.conditionalFieldPlaceHolderText[selectedLanguage]
                  "
                  :rows="fieldData.conditionalFieldMinRows || 3"
                  :max-rows="fieldData.conditionalFieldMaxRows || 6"
                  :state="
                    msg.xss
                      ? false
                      : isFocus &&
                        conditionalFieldInputValue &&
                        isMatchCondition &&
                        fieldData.validation.required == 1
                      ? true
                      : false
                  "
                  @focus="isFocus = true"
                ></b-form-textarea>
              </b-form-group>
            </div>
          </b-collapse>
          <div
            v-if="
              form1.formSection[sectionIndex].sectionTitle[selectedLanguage] ==
                'Services/Goods (Additional Question)' &&
                selectedCountriesFromSectionFour.length
            "
          >
            <em class="text-italic"
              >Please select country to view products by clicking the arrow
              below</em
            >

            <v-select
              :id="fieldData.id"
              :value="selectedProductCountry"
              :options="selectedCountriesFromSectionFour"
              :class="$store.state.rightAlign ? 'text-right' : 'text-left'"
              @input="onSelectCountryFromSectionFour"
            ></v-select>
            <b-badge
              class="mr-2 mt-2"
              v-for="(product, index) in selectedProducts"
              :key="index"
              variant="primary"
              >{{ product.product }}</b-badge
            >
          </div>
        </b-col>
      </b-row>
      <!-- advance settings tab -->
      <b-modal
        cancel-title="Close"
        ok-title="save"
        @ok="onSaveData"
        no-close-on-backdrop
        @hidden="onUpdateSettings"
        size="xl"
        v-model="showSettings"
        scrollable
        title="Radio button Advanced Settings"
      >
        <AdvanceRadioSettings
          v-if="showSettings"
          :fieldData="fieldData"
          :sectionIndex="sectionIndex"
          v-on:toggle-field="showSettings = !showSettings"
          :fieldIndex="fieldIndex"
        />
      </b-modal>
    </b-collapse>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import AdvanceRadioSettings from "../advanceRadioSettingsComponent.vue";
import { mapGetters, mapMutations, mapState } from "vuex";
import MenuButtons from "../menuButtons";
import { EventBus } from "@/event-bus.js";
import { Helper, Validate } from "../../helpers";
import HighRiskProducts from "../../utils/highRiskProducts.json";
import { HideSection } from "../../helpers";
import _ from "lodash";
export default {
  name: "RadioGroup",
  components: {
    AdvanceRadioSettings,
    MenuButtons,
  },
  data() {
    return {
      selectedHA: null,
      selectedProductCountry: null,
      selectedCountriesFromSectionFour: [],
      selectedProducts: [],
      allProducts: [],
      selectedSubDivisions: [],
      isHidden: false,
      isFocus: false,
      condition: {},
      showSettings: false,
      collapse: true,
      label: undefined,
      placeholder: undefined,
      helperText: undefined,
      isRequired: 1,
      selected: this.fieldData.selected || "",
      radioOptions: [],
      conditionalFieldLabel: null,
      conditionalFieldHelperText: null,
      conditionalFieldPlaceHolderText: null,
      conditionalFieldValidationMessage: null,
      conditionalFieldIsRequired: 0,
      conditionalFieldMaxRows: 1,
      conditionalFieldInputValue: null,
      conditionalFieldPostName: null,
      conditionalFieldIsVisible: 0,
      showCollapseField: false,
      isMatchCondition: false,
      msg: {},
    };
  },

  created() {
    EventBus.$on("onSubmitEndUserForm", (value) => {
      if (this.hasActiveXssError()) {
        this.$store.state.validFields = false;
        this.fieldData.isInValid = true;
        return;
      }
      if (value == "progress") {
        this.$store.state.validFields = true;
        this.fieldData.isInValid = false;
      }
      if (this.fieldData.isHidden) {
        // this.updateIsHiddenKeyToFormData();
        this.$store.state.validFields = true;
        this.fieldData.isInValid = false;
        this.fieldData.validation.required = 0;
      } else {
        if (
          this.fieldData.validation &&
          this.fieldData.validation.required == 1
        ) {
          if (!this.selected) {
            // console.log("this.selected", this.selected);
            this.isFocus = true;
            this.$store.state.validFields = false;
            this.fieldData.isInValid = true;
          } else if (this.selected) {
            if (this.fieldData.conditions && this.fieldData.conditions.length) {
              this.$store.state.validFields = true;
              this.fieldData.isInValid = false;
            }
            if (this.isMatchCondition) {
              if (!this.conditionalFieldInputValue) {
                this.isFocus = true;
                this.$store.state.validFields = false;
                this.fieldData.isInValid = true;
              } else {
                this.$store.state.validFields = true;
                this.fieldData.isInValid = false;
              }
            }
          } else {
            this.$store.state.validFields = true;
            this.fieldData.isInValid = false;
          }
        }
      }
    });

    EventBus.$on("OnInvalidFieldCatch", (inValidData) => {
      if (inValidData && inValidData.elementId) {
        document
          .getElementById(inValidData.elementId)
          .scrollIntoView({ behavior: "smooth" });
      }
    });

    EventBus.$on("onUpdateRadioValues", (value) => {
      this.setFieldValue();
      // this.setConditionInput();
    });

    EventBus.$on("getRefreshProducts", (products) => {
      this.allProducts = products;
    });
    EventBus.$on("getRefreshCountries", (countries) => {
      this.selectedCountriesFromSectionFour = countries;
    });

     EventBus.$on("onResetSelectedRadioValues", (ele) => {
       this.resetSelectedRadioValues(ele);
    });

    

    EventBus.$on("refreshProductList", (value) => {
      // console.log("asasasa-----", value)
      let sections = this.form1.formSection;
      let sectionSeven = sections.find(
        (sec) =>
          sec.sectionTitle[this.selectedLanguage] ==
          "Services/Goods (Additional Question)"
      );
      if (sectionSeven.formElements[0].id == this.fieldData.id) {
        this.selectedProductCountry = null;
        this.allProducts = [];
        this.selectedProducts = [];
        if (value == 0) {
          this.selectedCountriesFromSectionFour = [];
          HideSection.hideSection(
            this.$store.state,
            sectionSeven,
            this.selectedCountriesFromSectionFour
          );
          // this.allProducts = selectedProduct;
        } else {
          this.getCountryListFromSectionFour();
          this.refreshProducts(
            this.$store.state,
            sectionSeven,
            this.selectedCountriesFromSectionFour
          );
        }
      }
    });
  },

  beforeMount() {
    this.fieldData.selected = null;
  },
  beforeDestroy() {
    this.fieldData.selected = null;
  },
  mounted() {
    let sections = this.form1.formSection;
    this.isRequired = this.fieldData.validation.required;
    if (
      this.$route.name == "userform" ||
      this.$route.name == "EmployeeUserFormPage" ||
      this.$route.name == "EmployeeComplaintFormPage" ||
      this.$route.name == "ViewComplaints"
    ) {
      this.setFieldValue();
      this.setConditionInput();
    }

    let radios = this.fieldData.options;
    radios.map((radio) => {
      let pp = {
        value: radio.value,
        text: radio.text[this.selectedLanguage] || "No Text Set",
      };
      this.radioOptions.push(pp);
    });
    let sectionSeven = sections.find(
      (sec) =>
        sec.sectionTitle[this.selectedLanguage] ==
        "Services/Goods (Additional Question)"
    );
    if (sectionSeven && sectionSeven.formElements[0].id == this.fieldData.id) {
      if (sectionSeven) {
        this.getCountryListFromSectionFour();
        HideSection.hideSection(
          this.$store.state,
          sectionSeven,
          this.selectedCountriesFromSectionFour
        );
      }
    }
  },

  computed: {
    ...mapGetters([
      "form1",
      "selectedLanguage",
      "userForm",
      "userFormSubmitArray",
    ]),
    ...mapState(["toggleAllCoppalse"]),
  },

  watch: {
    toggleAllCoppalse(value) {
      this.collapse = value;
    },

    selectedHA(val) {
      console.log("val", val);
    },

    // allProducts(products){
    //   this.allProducts = products
    // },

    selectedLanguage(val) {
      this.radioOptions = [];
      let radios = this.fieldData.options;
      radios.map((radio) => {
        let pp = {
          value: radio.value,
          text: radio.text[this.selectedLanguage] || "No Text Set",
        };
        this.radioOptions.push(pp);
      });
    },
  },

  methods: {
    ...mapMutations(["TOGGLE_LOADER"]),

    updateIsHiddenKeyToFormData() {
      this.$store.state.userFormSubmitArray.map((a, index) => {
        if (a.elementId === this.fieldData.id) {
          // console.log("aaaaaaa", a.elementTitle['english'], a.isHiddenElement)
          // return a.isHiddenElement = 0
        }
      });
    },

    onUpdateSettings() {
      this.TOGGLE_LOADER(2);
    },

    getCountryListFromSectionFour() {
      this.selectedCountriesFromSectionFour = [];
      let sections = this.form1.formSection;
      let sectionFour = sections.find(
        (sec) =>
          sec.sectionTitle[this.selectedLanguage] == "Business Operations"
      );

      let eleNew = this.$store.state.userFormSubmitArray.find(
        (ele) => ele.elementId == sectionFour.formElements[0].id
      );

      if (eleNew && eleNew.elements.length) {
        eleNew.elements.map((el) => {
          if (el.postValue && el.postValue.length) {
            el.postValue.map((ans) => {
              // if (ans.riskScore == 13) {
              //  add lgic to push only those countries which has prodcuts
              // let countryProducts = this.checkForProductCountry(ans.name);
              // if (countryProducts && countryProducts.length > 0) {
              this.selectedCountriesFromSectionFour.push(ans.name);
              // }
            });
          } else {
            this.selectedCountriesFromSectionFour = [];
          }
        });
      }
    },

    checkForProductCountry(country) {
      // console.log("checkForProductCountry", country);
      var countryProducts = [];
      HighRiskProducts.industries.map((ind) => {
        if (ind && ind.subDivisions && ind.subDivisions.length) {
          ind.subDivisions.map((sd) => {
            if (sd && sd.counties && sd.counties.length) {
              sd.counties.map((cr) => {
                if (
                  cr.country == country &&
                  cr.products &&
                  cr.products.length > 0
                ) {
                  // console.log("crrrrr", cr);
                  cr.products.map((productObj) => {
                    if (productObj.product) {
                      // console.log("product flund", productObj);
                      countryProducts.push(productObj.product);
                    }
                  });
                }
              });
            }
          });
        }
      });
      return countryProducts;
    },

    refreshProducts(state, section, countries) {
      HideSection.hideSection(state, section, countries);
      // console.log("selectedProducts", selectedProducts)
      // this.allProducts = selectedProduct;
      // console.log("selectedProducts", this.allProducts);
    },

    onSelectCountryFromSectionFour(e) {
      // console.log("eeee", e);
      // console.log("let selectedProducts =", this.allProducts);
      this.selectedProductCountry = e;
      this.selectedProducts = [];
      for (let pr of this.allProducts) {
        let index = _.findIndex(this.selectedProducts, function(prd) {
          return prd.product == pr.product;
        });
        if (pr.country == e && index == -1) {
          this.selectedProducts.push(pr);
        }
      }
    },

    // temp disable
    onSelectCountryFromSectionFout(e) {
      this.selectedProductCountry = e;
      this.selectedProducts = [];
      let sections = this.form1.formSection;
      let products = HighRiskProducts;
      let selectedSubDivision = null;
      let multi = false;
      let selectedCountry = e;
      let sectionSix = sections.find(
        (sec) =>
          sec.sectionTitle[this.selectedLanguage] == "Details of Services/Goods"
      );

      let foundCombo = sectionSix.formElements.find(
        (a) => a.inputType == "comboSelectProgressive"
      );
      let eleNewCombo = this.$store.state.userFormSubmitArray.find(
        (ele) => ele.elementId == foundCombo.id
      );

      if (eleNewCombo && eleNewCombo.elements.length) {
        eleNewCombo.elements.map((el) => {
          // console.log("el", el)
          if (el.postValue && el.postValue.comboSelectTwo) {
            selectedSubDivision = el.postValue.comboSelectTwo;
            multi = el.isMultipleSelectSecond;
          }
        });
      }
      // console.log("selectedSubDivision", selectedSubDivision)
      // console.log("multi", multi)
      HighRiskProducts.industries.map((ind) => {
        if (ind && ind.subDivisions && ind.subDivisions.length) {
          ind.subDivisions.map((sd) => {
            let foundSubDivision =
              multi && selectedSubDivision
                ? selectedSubDivision.find(
                    (d) => d.subDivisionName == sd.subDivisionName
                  )
                : selectedSubDivision;
            if (
              (foundSubDivision &&
                sd.subDivisionName == foundSubDivision.subDivisionName) ||
              (foundSubDivision && sd.subDivisionName == foundSubDivision)
            ) {
              if (sd && sd.counties && sd.counties.length) {
                sd.counties.map((cr) => {
                  if (cr.country == selectedCountry) {
                    if (cr.products && cr.products.length) {
                      let product = cr.products.find((pr) => pr.product);
                      this.selectedProducts.push(product);
                    }
                    // this.selectedProducts = cr.products && cr.products.length ? cr.products : [];
                  }
                });
              }
            }
          });
        }
      });
    },

    initialCheckCondition(value) {
      let elements = this.form1.formSection[this.sectionIndex].formElements;
      let found = elements.find((ff, index) => {
        // // console.log("ff.conditions", ff.conditions)
        if (ff.conditions && ff.conditions.length) {
          ff.conditions.map((aa) => {
            // // console.log("aa", aa)
            if (
              aa.sourceFieldId === this.fieldData.id &&
              aa.targetFieldId !== this.fieldData.id &&
              aa.value === value &&
              // aa.label === this.fieldData.label[this.selectedLanguage]
              aa.label === this.fieldData.label["english"]
            ) {
              // console.log("------ condition iffffff");
              this.form1.formSection[this.sectionIndex].formElements[
                index
              ].isHidden = false;
              this.enableValidations(
                this.form1.formSection[this.sectionIndex].formElements[index]
              );
            } else if (
              aa.sourceFieldId === this.fieldData.id &&
              aa.targetFieldId !== this.fieldData.id &&
              aa.value !== value &&
              aa.label === this.fieldData.label["english"]
            ) {
              // console.log("------ ");
              this.form1.formSection[this.sectionIndex].formElements[
                index
              ].isHidden = true;

              // // console.log("this.form1.formSection[this.sectionIndex].formElements[index]", this.form1.formSection[this.sectionIndex].formElements[index])
              this.disableValidations(
                this.form1.formSection[this.sectionIndex].formElements[index]
              );
            } else {
              // this.form1.formSection[this.sectionIndex].formElements[index].isHidden = true;
            }
          });
        } else {
          // // console.log("------  elseeee");
          // this.form1.formSection[this.sectionIndex].formElements[index].isHidden = false;
        }
      });
    },

    checkCondition(value) {
      // console.log("checkCondition", value);
      this.isFocus = false;
      this.$store.state.validFields = true;
      this.fieldData.isInValid = false;

      let elements = this.form1.formSection[this.sectionIndex].formElements;

      // for section conditions
      let foundSection = elements.find((ff, index) => {
        if (ff.sectionConditions && ff.sectionConditions.length) {
          ff.sectionConditions.map((aa) => {
            if (aa.forSection) {
              if (this.form1.formSection[aa.selectedSection]) {
                if (
                  aa.id ===
                  this.form1.formSection[aa.selectedSection].condition.id
                ) {
                  // // console.log("------pppp-----")
                  if (
                    aa.sourceSectionId === this.fieldData.id &&
                    aa.value === value
                  ) {
                    // console.log("------ooooo-----")
                    this.selected = "";
                    this.fieldData.selected = null;
                    this.form1.formSection[aa.selectedSection].isHidden = true;
                  } else {
                    // // console.log("-------nnnn------")
                    this.form1.formSection[aa.selectedSection].isHidden = false;
                  }
                }
              }
            }
          });
        }
      });
      this.resetPregressiveElements(this.fieldData);
      let found = elements.find((ff, index) => {
        // // console.log("ff.conditions", ff.conditions)
        if (ff.conditions && ff.conditions.length) {
          ff.conditions.map((aa) => {
            // console.log("aa", aa);
            if (
              aa.sourceFieldId === this.fieldData.id &&
              aa.targetFieldId !== this.fieldData.id &&
              aa.value === value &&
              // aa.label === this.fieldData.label[this.selectedLanguage]
              aa.label === this.fieldData.label["english"]
            ) {
              // console.log("------ condition iffffff");
              this.form1.formSection[this.sectionIndex].formElements[
                index
              ].isHidden = false;
              this.enableValidations(
                this.form1.formSection[this.sectionIndex].formElements[index]
              );
            } else if (
              aa.sourceFieldId === this.fieldData.id &&
              aa.targetFieldId !== this.fieldData.id &&
              aa.value !== value &&
              aa.label === this.fieldData.label["english"]
            ) {
              // console.log("------ condition hidden true elseeeee if");
              this.form1.formSection[this.sectionIndex].formElements[
                index
              ].isHidden = true;
              // // console.log("this.form1.formSection[this.sectionIndex].formElements[index]", this.form1.formSection[this.sectionIndex].formElements[index])
              this.disableValidations(
                this.form1.formSection[this.sectionIndex].formElements[index]
              );
            } else {
              // this.form1.formSection[this.sectionIndex].formElements[index].isHidden = true;
            }
          });
        } else {
          // // console.log("------  elseeee");
          // this.form1.formSection[this.sectionIndex].formElements[index].isHidden = false;
        }
      });

      // for new conditional fields..

      if (
        this.fieldData.selectedConditionalFieldValue &&
        this.fieldData.selectedConditionalFieldValue == value
      ) {
        // if(this.fieldData.conditionalShowHiddenOption == 1){
        this.showCollapseField = true;
        this.conditionalFieldIsVisible = 1;
        this.isMatchCondition = true;
        // }
      } else {
        this.showCollapseField = false;
        this.conditionalFieldIsVisible = 0;
        this.conditionalFieldInputValue = null;
        this.msg = {};
        this.isMatchCondition = false;
      }

      this.setValue(value);
    },

    setConditionInput() {
      if (
        this.fieldData.selectedConditionalFieldValue &&
        this.fieldData.selectedConditionalFieldValue == this.selected
      ) {
        // if(this.fieldData.conditionalShowHiddenOption == 1){
        this.showCollapseField = true;
        this.conditionalFieldIsVisible = 1;
        this.isMatchCondition = true;
        this.isFocus = true;

        // }
      } else {
        this.showCollapseField = false;
        this.conditionalFieldIsVisible = 0;
        this.conditionalFieldInputValue = null;
        this.msg = {};
        this.isMatchCondition = false;
        this.isFocus = false;
      }
      // if (this.fieldData.conditions && this.fieldData.conditions.length) {
      //   this.isMatchCondition = true;
      // }
    },

    setFieldValue() {
      this.$store.state.getUserFormSubmitArray.length &&
        this.$store.state.getUserFormSubmitArray.map((a, index) => {
          if (a && a.elementId && a.elements && a.elements.length) {
            if (a.elementId === this.fieldData.id) {
              a.elements.map((el) => {
                if (el.key == "radio") {
                  this.selected = el.postValue;
                  this.fieldData.selected = el.postValue;
                } else if (el.key == "progressive") {
                  this.conditionalFieldInputValue = el.postValue;
                }
              });
            }
          }
        });
      // console.log("this.selected", this.selected)
      this.initialCheckCondition(this.selected);
    },

    setValue(e) {
      // console.log("onInputType radio", e);
      // console.log("[this.fieldData radio", this.fieldData.options.find(rr=> rr.value == e));

      let pos = this.radioOptions
        .map(function(r) {
          return r.value;
        })
        .indexOf(e);
      // // console.log("e", this.radioOptions[pos].text)
      let languageValue = this.radioOptions[pos].text;
      const registerData = _.clone(this.$store.state.registerData);

      if (
        this.$route.name == "userform" ||
        this.$route.name == "EmployeeUserFormPage" ||
        this.$route.name == "EmployeeComplaintFormPage" ||
        this.$route.name == "ViewComplaints"
      ) {
        this.selected = e;
        this.fieldData.selected = e;
        if (e && e.length > 0 && !this.conditionalFieldIsVisible) {
          this.conditionalFieldInputValue = null;
          this.msg = {};
          registerData[this.fieldData.id] = e;
        } else {
          delete registerData[this.fieldData.id];
        }
        this.$store.state.registerData = registerData;

        // main calculations :p
        const numkeys = Object.keys(registerData).length;
        this.$store.state.progressValue = numkeys;
        // console.log("selected", this.selected)
        // console.log("selectedLanguage", this.selectedLanguage)
        // console.log("fieldDataoption", this.fieldData.options)
        if (this.selected) {
          let option = this.fieldData.options.find(
            (opt) => opt.value == this.selected
          );
          // console.log("option", option)
          let selectedRadioOptionsPostValueAbb = [];
          let selectedRadioOptionsCustomValues = [];
          selectedRadioOptionsPostValueAbb.push(option.postValueAbb);
          selectedRadioOptionsCustomValues.push(option.custom_values);
          this.$store.state.userFormSubmitArray.map((a, index) => {
            if (a.elementId === this.fieldData.id) {
              a.elements[0] = {
                language: this.selectedLanguage,
                valueForPDF: languageValue,
                postValue: this.selected,
                postValueText: option.text || null,
                postValueAbb: selectedRadioOptionsPostValueAbb || null,
                key: "radio",
                score: option && option.score ? option.score : null,
                custom_values: selectedRadioOptionsCustomValues || null,
                postName:
                  (this.fieldData.attributes &&
                    this.fieldData.attributes.postName) ||
                  "postNameRadio",
              };
            }
          });
        }
      }
    },

    checkXss(value) {
      if (!Validate.noXSS(value)) {
        this.msg["xss"] = true;
        return true;
      }
      this.msg["xss"] = false;
      return false;
    },

    hasActiveXssError() {
      return Object.keys(this.msg).some((key) => key.startsWith("xss") && this.msg[key]);
    },

    onInputType(e) {
      const hasXss = this.checkXss(e);
      const registerData = _.clone(this.$store.state.registerData);
      if (
        this.$route.name == "userform" ||
        this.$route.name == "EmployeeUserFormPage" ||
        this.$route.name == "EmployeeComplaintFormPage" ||
        (this.$route.name == "ViewComplaints" && this.showCollapseField)
      ) {
        if (e && e.length > 0) {
          registerData[this.fieldData.id] = e;
        } else {
          delete registerData[this.fieldData.id];
        }
        this.$store.state.registerData = registerData;

        // main calculations :p
        let numkeys = Object.keys(registerData).length;
        this.$store.state.progressValue = numkeys;

        if (!hasXss) {
          this.$store.state.userFormSubmitArray.map((a, index) => {
            if (a.elementId === this.fieldData.id) {
              a.elements[1] = {
                postValue: e,
                key: "progressive",
                postNameProgressive:
                  this.fieldData.conditionalFieldLabel || "postNameProgressive",
              };
            }
          });
        }
      }
    },

    onSaveData() {
      EventBus.$emit("onSaveSettings", "saving settings");
      Helper.makeToast(this.$bvToast, "success", "Settings Updated");
    },

    // for disbakbe vlaidations
    disableValidations(element) {
      switch (element.inputType) {
        case "input":
          this.$store.state.getUserFormSubmitArray.length &&
            this.$store.state.getUserFormSubmitArray.map((a, index) => {
              if (a.elementId == element.id) {
                a.elements.map((el) => {
                  // // console.log("elllll input", el)
                  return (el.postValue = null);
                  // this.fieldData.isHidden = el.postValue.length ? false: true
                });
              }
            });
          EventBus.$emit("onUpdateInputValues", "");
          break;
        case "radio":
          // console.log("case radio in radio", element);
          this.$store.state.getUserFormSubmitArray.length &&
            this.$store.state.getUserFormSubmitArray.map((a, index) => {
              // console.log("el radio", a.label['english']);
              if (a.elementId == element.id) {
                a.isHiddenElement = 1;
                // this.resetPregressiveElement(a);
                a.elements.map((el) => {
                  return (el.postValue = null), (el.score = 0);
                });
                // EventBus.$emit("onUpdateRadioValues", "");
              }
            });
          this.$store.state.userFormSubmitArray.length &&
            this.$store.state.userFormSubmitArray.map((a, index) => {
              // console.log("el radio", a.label['english']);
              if (a.elementId == element.id) {
                a.isHiddenElement = 1;
                // this.resetPregressiveElement(a);
                a.elements.map((el) => {
                  return (el.postValue = null), (el.score = 0);
                });
                // EventBus.$emit("onUpdateRadioValues", "");
              }
            });

          element.isInValid = false;
          element.validation.required = 0;
          // code block

          break;
        case "checkbox":
          // console.log("checkbox in radio", element);
          this.$store.state.getUserFormSubmitArray.length &&
            this.$store.state.getUserFormSubmitArray.map((a, index) => {
              if (a.elementId == element.id) {
                a.isHiddenElement = 1;
                EventBus.$emit("onResetCheckBox", a);
                a.elements.map((el) => {
                  // console.log("el checkbox", el);
                  return (el.postValue = null), (el.score = 0);
                });
                // EventBus.$emit("onUpdateCheckboxValues", "");
              }
            });
          this.$store.state.userFormSubmitArray.length &&
            this.$store.state.userFormSubmitArray.map((a, index) => {
              if (a.elementId == element.id) {
                a.isHiddenElement = 1;
                EventBus.$emit("onResetCheckBox", a);
                a.elements.map((el) => {
                  // console.log("el checkbox", el);
                  return (el.postValue = null), (el.score = 0);
                });
                // EventBus.$emit("onUpdateCheckboxValues", "");
              }
            });
          element.isInValid = false;
          element.validation.required = 0;
          // code block

          break;
        case "countries":
          // console.log("case countries in radio", element);
          this.$store.state.getUserFormSubmitArray.length &&
            this.$store.state.getUserFormSubmitArray.map((a, index) => {
              if (a.elementId == element.id) {
                a.elements = [];
                a.isHiddenElement = 1;
                EventBus.$emit("onRestoreCountry", a);
              }
            });
          this.$store.state.userFormSubmitArray.length &&
            this.$store.state.userFormSubmitArray.map((a, index) => {
              if (a.elementId == element.id) {
                a.elements = [];
                a.isHiddenElement = 1;
                EventBus.$emit("onRestoreCountry", a);
              }
            });
          break;
        case "individual-shareholders":
          // element.validation.isRequireFreeForm = false;
          // element.validation.isRequireLastName = false;
          // element.validation.isRequireFirstName = false;
          // element.validation.isRequireDateOfBirth = false;
          // element.validation.isRequireCountryOfBirth = false;
          // element.validation.isRequirePassportNumber = false;
          // element.validation.isRequirePercentageOwned = false;
          element.isInValid = false;
          // code block
          break;
        default:
          element.isInValid = false;
          element.validation.required = 0;
        // code block
      }
      // this.resetPregressiveElements(this.fieldData);
    },

    enableValidations(element) {
      // console.log("enableValidations element", element);
      switch (element.inputType) {
        case "individual-shareholders":
          element.isInValid = true;
          // code block
          break;
        case "checkbox":
          // console.log("enableValidations checkbox in radio", element);
          this.$store.state.getUserFormSubmitArray.length &&
            this.$store.state.getUserFormSubmitArray.map((a, index) => {
              if (a.elementId == element.id) {
                a.isHiddenElement = 0;
                // element.isInValid = true;
                element.validation.required = 0;
              }
            });
          this.$store.state.userFormSubmitArray.length &&
            this.$store.state.userFormSubmitArray.map((a, index) => {
              if (a.elementId == element.id) {
                a.isHiddenElement = 0;
              }
            });

          // code block

          break;
        case "radio":
          // console.log("case radio in radio disabled", element);
          this.$store.state.getUserFormSubmitArray.length &&
            this.$store.state.getUserFormSubmitArray.map((a, index) => {
              // console.log("el radio", a.label['english']);
              if (a.elementId == element.id) {
                a.isHiddenElement = 0;
                a.elements.map((el) => {
                  // this.resetPregressiveElement(a);
                  // console.log("el radio", a);
                  // this.fieldData.isHidden = el.postValue.length ? false: true
                  // return (el.postValue = null), (el.score = 0);
                });
                // EventBus.$emit("onUpdateRadioValues", "");
              }
            });
          this.$store.state.userFormSubmitArray.length &&
            this.$store.state.userFormSubmitArray.map((a, index) => {
              if (a.elementId == element.id) {
                a.isHiddenElement = 0;
              }
            });

          element.isInValid = true;
          element.validation.required = 1;
          // code block

          break;
        case "countries":
          // console.log("case countries in radio", element);
          this.$store.state.getUserFormSubmitArray.length &&
            this.$store.state.getUserFormSubmitArray.map((a, index) => {
              if (a.elementId == element.id) {
                a.isHiddenElement = 0;
              }
            });
          this.$store.state.userFormSubmitArray.length &&
            this.$store.state.userFormSubmitArray.map((a, index) => {
              if (a.elementId == element.id) {
                a.isHiddenElement = 0;
              }
            });
          break;
        default:
          // code block
          element.isInValid = true;
          element.validation.required = 1;
      }
    },

    resetPregressiveElements(selectedElement) {
      for (let conditionalField of selectedElement.conditionalFields) {
          for (let frmSection of this.form1.formSection) {
            let foundSection = frmSection.formElements;
            for (let element of foundSection) {
              if (element.id == conditionalField.targetFieldId && element.id != conditionalField.sourceFieldId) {
                if(element.inputType === "checkbox"){
                EventBus.$emit("onResetSelectedValues", element);
                }
                element.selected = null;
                element.isHidden = true;
                if (this.$store.state.getUserFormSubmitArray.length) {
                  for (let ele of this.$store.state.getUserFormSubmitArray) {
                    if (ele.elementId == element.id) {
                      ele.elements = [];
                      ele.isHiddenElement = 1;
                    }
                  }
                }
                if (this.$store.state.userFormSubmitArray.length) {
                  for (let ele of this.$store.state.userFormSubmitArray) {
                    if (ele.elementId == element.id) {
                      ele.elements = [];
                      ele.isHiddenElement = 1;
                    }
                  }
                }
                  this.resetPregressiveElements(element);
              }
            }
          }
      }
      
    },

    
    resetPregressiveElement(selectedElement) {
      let foundSection = this.form1.formSection[selectedElement.sectionIndex].formElements;
      for (let element of foundSection) {
        if (element.conditions && element.conditions.length && element.id != this.fieldData.id) {
          if(element.inputType === "checkbox"){
          EventBus.$emit("onResetSelectedValues", element);
          }
          element.selected = null;
          element.isHidden = true;
          if (this.$store.state.getUserFormSubmitArray.length) {
            for (let ele of this.$store.state.getUserFormSubmitArray) {
              if (ele.elementId == element.id) {
                ele.elements = [];
                ele.isHiddenElement = 1;
              }
            }
          }
          if (this.$store.state.userFormSubmitArray.length) {
            for (let ele of this.$store.state.userFormSubmitArray) {
              if (ele.elementId == element.id) {
                ele.elements = [];
                ele.isHiddenElement = 1;
              }
            }
          }

          // if (element.inputType == "checkbox") {
          //   EventBus.$emit("onResetCheckBox", selectedElement);
          // }
        }
      }
    },

    resetSelectedRadioValues(selectedElement){
       if (selectedElement.id === this.fieldData.id) {
        this.fieldData.selected = null;
        this.selected = "";
      }
    }
  },

  props: {
    fieldData: Object,
    isPreview: Boolean,
    sectionIndex: Number,
    fieldIndex: Number,
    isDisabled: Number,
  },
};
</script>
<style>
.custom-control-label::before {
  /* left: -1.5rem; */
  right: 0 !important;
}
.custom-control-label {
  padding-right: 25px;
}
.custom-control-input:checked ~ .custom-control-label::after {
  right: 0 !important;
}
</style>
